import create from 'zustand';

import { uploadMusicTypes } from '@/types';

interface UploadMusic {
  formvalues: uploadMusicTypes.UploadMusic;
  setFormValues: (data: uploadMusicTypes.UploadMusic) => void;
  isUploadDone: boolean;
  setIsUploadDone: (data: boolean) => void;
}

const uploadMusicStore = create<UploadMusic>((set) => ({
  formvalues: uploadMusicTypes.INITIAL_STATE,
  isUploadDone: false,

  setFormValues: (data: uploadMusicTypes.UploadMusic) => set({ formvalues: data }),
  setIsUploadDone: (data: boolean) => set({ isUploadDone: data }),
}));

export default uploadMusicStore;
